import Access from './Access'

export default Access
